export default __webpack_public_path__ + "static/media/Blog14.3ae31596.png";